/* eslint-disable prettier/prettier */
import { NgModule } from '@angular/core';
import { SharedModule } from '../~shared/modules/shared.module';
import { ProfileWrapperComponent } from './components/profile-wrapper/profile-wrapper.component';
import { UserInformationComponent } from './components/user-information/user-information.component';
import { PersonalInformationComponent } from './components/personal-information/personal-information.component';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PersonalInformationFormComponent } from './components/personal-information-form/personal-information-form.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChangePasswordFormComponent } from './components/change-password-form/change-password-form.component';
import { UserSubscriptionCardComponent } from './components/user-subscription-card/user-subscription-card.component';
import { UserSubscriptionComponent } from './components/user-subscription/user-subscription.component';
import { UserSubscriptionCreationDialogComponent } from './components/user-subscription-creation-dialog/user-subscription-creation-dialog.component';

const DECLARATIONS = [
  ProfileWrapperComponent,
  UserInformationComponent,
  PersonalInformationComponent,
  ProfileCardComponent,
  PersonalInformationFormComponent,
  ChangePasswordComponent,
  ChangePasswordFormComponent,
  UserSubscriptionCardComponent,
  UserSubscriptionComponent,
  UserSubscriptionCreationDialogComponent
  
];

const MODULES = [
  SharedModule,
  MatTabsModule,
  MatFormFieldModule,
  MatInputModule
];

@NgModule({
  declarations: DECLARATIONS,
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS]
})
export class ProfileModule {}
